<script>
	export let block;
	export let data;
	export let index;
	export let j;
	export let type = '';

	import { saved, changed, isNewDataChanged, imageNotifyError, imageSize } from '../../../../../stores/variables';
	import { localUrl } from '../../../../../scripts/is_local';
	import { addNotify } from '../../../../../scripts/notification';

	if (!block.src) block.src = [];
	if (!block.files) block.files = [];
	if (!block.newData) block.newData = [];
	if (block.newData) {
		if (block.newData[block.field_name]) {
			block.src[0] = localUrl('https://topdent.ru', block.newData[block.field_name]);
		}
	}

	function showImage() {
		block.deleted = false;
		if (type != 'new') data.loadedData[index]['Image-deleted'] = false;
		Array.from(block.files).forEach((image) => {
			let reader = new FileReader();
			reader.readAsDataURL(image);
			reader.onload = (e) => {
				block.src = [];
				block.src.push(e.target.result);
				block.src = block.src;
			};
		});
	}
	function deleteImg() {
		$changed = true;
		if (data[data.field_name] && data[data.field_name][index] && data[data.field_name][index].active) {
			block.deleted = true;
		}
		if (data[data.field_name + '_new'] && data[data.field_name + '_new'][index] && data[data.field_name + '_new'][index].active) {
			block.src[0] = '';
			block.files = [];
		}
	}
	function recoverImg() {
		if (data[data.field_name][index].active) {
			block.deleted = false;
		}
	}

	let loaded;
	if (!loaded) {
		if (!block.deleted) block.deleted = '';
		if (!block.loaded) block.loaded = [];
		block.loaded.deleted = block.deleted;
		block.loaded.src = block.src[0];
		block.files.length > 0 ? (block.loaded.files = true) : (block.loaded.files = false);
		loaded = '1';
	}

	$: if ($saved) {
		if (data[data.field_name] && data[data.field_name][index] && data[data.field_name][index].active) {
			if ($saved == 'saved') {
				$isNewDataChanged = true;
				block.newData[block.field_name] = block.src[0];
				data.loadedData[index][block.field_name] = block.src[0];
				data[data.field_name][index][j] = block;
				data.loadedData[index]['toUpdate'] = true;
				data.loadedData[index]['Image-deleted'] = block.deleted;

				if (data.newData[data.field_name].length < 1) {
					data.newData[data.field_name].push(data.loadedData[index]);
				} else {
					let check = false;
					data.newData[data.field_name].forEach((new_sp) => {
						if (new_sp['ID'] == data.loadedData[index]['ID']) check = true;
					});
					if (!check) {
						data.newData[data.field_name].push(data.loadedData[index]);
						check = false;
					}
				}
			}
			if ($saved == 'canceled') {
				block.deleted = block.loaded.deleted;
				data.loadedData[index]['Image-deleted'] = block.deleted;
				block.src[0] = block.loaded.src;
				if (!block.loaded.files) block.files = [];
			}
		}
		if (data[data.field_name + '_new'] && data[data.field_name + '_new'][index] && data[data.field_name + '_new'][index].active) {
			if ($saved == 'saved') {
				$isNewDataChanged = true;
				if (block.src[0]) {
					block.newData[block.field_name] = block.src[0];
					data.createdData[index][block.field_name] = block.src[0];
				} else {
					block.newData[block.field_name] = '';
					data.createdData[index][block.field_name] = '';
				}
				data[data.field_name + '_new'][index][j] = block;

				if (data.newData[data.field_name].length < 1) {
					data.newData[data.field_name].push(data.createdData[index]);
				} else {
					let check = false;
					data.newData[data.field_name].forEach((new_sp) => {
						if (new_sp.temp_id == data.createdData[index].temp_id) check = true;
					});
					if (!check) {
						data.newData[data.field_name].push(data.createdData[index]);
						check = false;
					}
				}
			}

			if ($saved == 'canceled') {
				block.deleted = block.loaded.deleted;
				data.createdData[index]['Image-deleted'] = block.deleted;
				block.src[0] = block.loaded.src;
				if (!block.loaded.files) block.files = [];
			}
		}
	}
</script>

{#if block}
	<div class="modal__item-name" style="flex-direction: column;">
		<span class="modal__item-name-text">{block.name ? block.name : ''}</span>
		<p class="info">Внимание: загружайте только те фотографии, на которые у вас авторское право</p>
		<p class="info">Принимаемые к загрузке форматы и размеры изображения: .png, .jpg, .jpeg до 2 МБ</p>
	</div>
	<div class="content">
		{#if type == 'new'}
			<label title={$imageNotifyError}>
				<input
					type="file"
					bind:files={block.files}
					on:change={(e) => {
						if (block.files[0].size > 2097152) {
							addNotify($imageNotifyError, 'error');
							e.target.value = '';
							block.src = [];
						} else {
							showImage();
							$changed = 1;
						}
					}}
					name={'image_doctor_' + data.createdData[index]['temp_id']}
					accept=".png, .jpg, .jpeg"
				/>
				<span><i /></span>
			</label>
		{:else}
			<label title={$imageNotifyError}>
				<input
					type="file"
					bind:files={block.files}
					on:change={(e) => {
						if (block.files[0].size > 2097152) {
							addNotify($imageNotifyError, 'error');
							e.target.value = '';
							block.src = [];
						} else {
							showImage();
							$changed = 1;
						}
					}}
					name={'image_doctor_' + data.loadedData[index]['ID']}
					accept=".png, .jpg, .jpeg"
				/>
				<span><i /></span>
			</label>
		{/if}
		{#if block.files}
			{#each block.src as image, i}
				{#if image}
					<div class="image {block.deleted ? 'deleted' : ''}">
						{#if !block.deleted}
							<span class="cross" on:click={() => deleteImg()}>
								<i class="far fa-times" />
							</span>
						{:else}
							<div class="image__deleted" />
							<span class="cross" on:click={() => recoverImg()}>
								<i class="far fa-check" />
							</span>
						{/if}
						<img src={image} alt="" />
					</div>
				{/if}
			{/each}
		{/if}
	</div>
{/if}

<style lang="scss">
	.info {
		margin: 5px 0 5px 0;
		font-size: 14px;
		font-weight: 500;
		color: var(--text-gray-3);
	}
	.content {
		display: flex;
		flex-wrap: wrap;
		padding: 18px 20px;
		width: 100%;

		.image {
			display: flex;
			position: relative;
			overflow: hidden;
			border: solid 2px #00000000;

			&__deleted {
				position: absolute;
				top: 0;
				left: 0;
				bottom: 0;
				right: 0;
				border-radius: 20px;
				background: #ff00001c;
				display: flex;
				align-items: center;
				justify-content: center;
				&::before,
				&::after {
					content: '';
					width: 100%;
					height: 2px;
					background: var(--color-4);
					display: flex;
					position: absolute;
				}
				&::before {
					transform: rotate(45deg);
				}
				&::after {
					transform: rotate(-45deg);
				}
			}

			&.deleted {
				border-color: var(--color-4);
			}

			> img {
				height: 100%;
				width: 100%;
				object-fit: cover;
			}
		}
		.cross {
			position: absolute;
			right: 4px;
			top: 4px;
			display: flex;
			align-items: center;
			justify-content: center;
			height: 20px;
			width: 20px;
			z-index: 11;
			cursor: pointer;

			&:hover {
				&::before {
					opacity: 1;
				}
			}

			> i {
				display: flex;
				font-size: 16px;
				color: #fff;
				z-index: 1;
			}
			&::before {
				background: black;
				content: '';
				height: 100%;
				width: 100%;
				position: absolute;
				opacity: 0.7;
				border-radius: 4px;
				transition: all 0.1s ease-in;
			}
		}
		.image,
		> label {
			height: 60px;
			width: 60px;
			margin: 0 5px 5px 0;
			border-radius: 8px;
		}

		> label {
			display: flex;
			flex-shrink: 0;
			align-items: center;
			justify-content: center;
			background: var(--color-1);
			cursor: pointer;

			> input {
				display: none;
			}

			> span {
				height: 50%;
				width: 50%;
				border-radius: 50%;
				border: solid 4px var(--bg-main-1);

				> i {
					height: 100%;
					width: 100%;
					display: flex;
					align-items: center;
					justify-content: center;
					position: relative;

					&::before,
					&::after {
						content: '';
						height: 50%;
						width: 4px;
						background-color: var(--bg-main-1);
					}

					&::after {
						transform: rotate(90deg);
						margin-left: -4px;
					}
				}
			}
		}
	}
</style>
